/**
 * MainSettingsSection Component
 * 
 * Principal settings section including:
 * - Print orders toggle
 * - Desktop app download
 * - Default tip configuration
 * - Main cash register (caja) selection
 */

import React from 'react';
import { Form, Dropdown, Button } from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
import { IoMdArrowDropdown } from 'react-icons/io';
import { MEDIO_PUNTO_APP_URL, validateTipValue } from '../../utils';
import type { CajaOption } from '../../components/utils/utils';
import './MainSettingsSection.scss';

interface MainSettingsSectionProps {
  imprimirOrden: boolean;
  dafualtTip: string;
  caja: string;
  cajas: CajaOption[];
  onImprimirOrdenChange: (value: boolean) => void;
  onDefaultTipChange: (value: string) => void;
  onCajaChange: (value: string) => void;
}

const MainSettingsSection: React.FC<MainSettingsSectionProps> = ({
  imprimirOrden,
  dafualtTip,
  caja,
  cajas,
  onImprimirOrdenChange,
  onDefaultTipChange,
  onCajaChange,
}) => {
  const handleTipChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (validateTipValue(value)) {
      onDefaultTipChange(value);
    }
  };

  return (
    <div className="settings-card">
      <h4>Principal</h4>
      
      {/* Print Orders Toggle */}
      <div className="form-field">
        <label className="field-label">Imprimir órdenes</label>
        <label className="switch">
          <input
            type="checkbox"
            checked={imprimirOrden}
            onChange={() => onImprimirOrdenChange(!imprimirOrden)}
          />
          <span className="slider round"></span>
        </label>
      </div>

      {/* Desktop App Download */}
      {imprimirOrden && (
        <div className="form-field">
          <label className="field-label">Descargar aplicación de escritorio</label>
          <a href={MEDIO_PUNTO_APP_URL} download>
            <Button variant="none" className="download-button">
              <FaDownload /> Descargar
            </Button>
          </a>
        </div>
      )}

      {/* Default Tip */}
      <div className="form-field">
        <label className="field-label">Propina por defecto</label>
        <div className="tip-input-container">
          <Form.Control
            type="number"
            placeholder="Propina"
            value={dafualtTip}
            onChange={handleTipChange}
            className="modern-input"
          />
          <span className="input-suffix">%</span>
        </div>
      </div>

      {/* Main Caja */}
      <div className="form-field">
        <label className="field-label">Caja principal</label>
        <Dropdown>
          <Dropdown.Toggle className="modern-dropdown" id="dropdown-caja-principal">
            {cajas.find((cajaItem) => cajaItem.id.toString() === caja)?.label ||
              'Seleccionar Caja'} <IoMdArrowDropdown />
          </Dropdown.Toggle>
          <Dropdown.Menu className="modern-dropdown-menu">
            {cajas.map((cajaItem) => (
              <Dropdown.Item
                key={cajaItem.id}
                onClick={() => onCajaChange(cajaItem.id.toString())}
                active={caja === cajaItem.id.toString()}
              >
                {cajaItem.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default MainSettingsSection;
